import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'open',
  component: () => import('@/views/open.vue'),
  meta:{
    keepAlive:true
  },
},
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@/views/activity.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/science',
    name: 'science',
    component: () => import('@/views/science.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/mall',
    name: 'mall',
    component: () => import('@/views/mall.vue'),
    meta:{
      keepAlive:true
    },
  },
  // {
  //   path: '/achievement',
  //   name: 'achievement',
  //   component: () => import('@/views/achievement.vue'),
  //   meta:{
  //     keepAlive:true
  //   },
  // },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('@/views/technology.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/achievements',
    name: 'achievements',
    component: () => import('@/views/achievements.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/open',
    name: 'open',
    component: () => import('@/views/open.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/carrierTech',
    name: 'carrierTech',
    component: () => import('@/views/carrierTech.vue'),
    meta:{
      keepAlive:true
    },
  },
  {
    path: '/techTalents',
    name: 'techTalents',
    component: () => import('@/views/techTalents.vue'),
    meta:{
      keepAlive:true
    },
  },
  // {
  //   path: '/base',
  //   name: 'base',
  //   component: () => import('../views/base.vue')
  // },
  {
    path: '/base',
    name: 'base',
    component: () => import('@/views/newbase.vue'),
    meta:{
      keepAlive:true
    },
  },
]
const router = new VueRouter({
  // mode: "history",
  routes
})

export default router